export const PATIENTS = [ //replicated data for placeholder, only this one is used
  {
    id: 14757, grup_edat: '90+', sexe: 'H', cronic: 'NO',
    prob_mort: 0.899, prob_urgencia: 0.39, prob_pcc: 0,
    diags: 0, farmacs: 7, urgencies: 1, ingressos: 1,
    nearest_pcc: [34324, 13524, 33063],
    shap: [
      { name: 'farmacs_totals',         value: 7,  shap:  0.31 },
      { name: 'grup_edat_90+',          value: 1,  shap:  0.28 },
      { name: 'n_visites_primaria',     value: 59, shap:  0.19 },
      { name: 'sistema_cardiovascular', value: 2,  shap:  0.14 },
      { name: 'n_urgencies',            value: 1,  shap:  0.11 },
      { name: 'n_ingressos',            value: 1,  shap:  0.09 },
      { name: 'diags_totals',           value: 0,  shap: -0.08 },
      { name: 'problemes_cronics',      value: 0,  shap: -0.06 },
    ]
  },
  {
    id: 18341, grup_edat: '90+', sexe: 'D', cronic: 'PCC',
    prob_mort: 0.58, prob_urgencia: 0.43, prob_pcc: null,
    diags: 17, farmacs: 10, urgencies: 2, ingressos: 1,
    nearest_pcc: null,
    shap: [
      { name: 'diags_totals',       value: 17, shap:  0.29 },
      { name: 'grup_edat_90+',      value: 1,  shap:  0.22 },
      { name: 'sistema_nervios',    value: 2,  shap:  0.18 },
      { name: 'n_urgencies',        value: 2,  shap:  0.15 },
      { name: 'farmacs_totals',     value: 10, shap:  0.12 },
      { name: 'ingres_urgent',      value: 1,  shap:  0.09 },
      { name: 'sexe_D',             value: 1,  shap: -0.05 },
    ]
  },
  {
    id: 6334, grup_edat: '90+', sexe: 'D', cronic: 'MACA',
    prob_mort: 0.89, prob_urgencia: 0.82, prob_pcc: null,
    diags: 11, farmacs: 19, urgencies: 2, ingressos: 1,
    nearest_pcc: null,
    shap: [
      { name: 'farmacs_totals',     value: 19, shap:  0.42 },
      { name: 'cronic_MACA',        value: 1,  shap:  0.35 },
      { name: 'diags_totals',       value: 11, shap:  0.21 },
      { name: 'n_urgencies',        value: 2,  shap:  0.18 },
      { name: 'cardiovascular',     value: 3,  shap:  0.14 },
      { name: 'antineoplasics',     value: 1,  shap:  0.11 },
      { name: 'n_visites_primaria', value: 31, shap: -0.04 },
    ]
  },
  {
    id: 23821, grup_edat: '90+', sexe: 'D', cronic: 'NO',
    prob_mort: 0.42, prob_urgencia: 0.31, prob_pcc: 0.72,
    diags: 18, farmacs: 7, urgencies: 1, ingressos: 0,
    nearest_pcc: [9635, 36898, 8743],
    shap: [
      { name: 'diags_totals',       value: 18, shap:  0.24 },
      { name: 'grup_edat_90+',      value: 1,  shap:  0.19 },
      { name: 'n_visites_primaria', value: 22, shap:  0.13 },
      { name: 'farmacs_totals',     value: 7,  shap:  0.11 },
      { name: 'n_urgencies',        value: 1,  shap:  0.08 },
      { name: 'n_ingressos',        value: 0,  shap: -0.12 },
      { name: 'farmacs_cronics',    value: 0,  shap: -0.09 },
    ]
  },
  {
    id: 16221, grup_edat: '90+', sexe: 'H', cronic: 'PCC',
    prob_mort: 0.71, prob_urgencia: 0.76, prob_pcc: null,
    diags: 11, farmacs: 11, urgencies: 8, ingressos: 2,
    nearest_pcc: null,
    shap: [
      { name: 'n_urgencies',        value: 8,    shap:  0.38 },
      { name: 'farmacs_totals',     value: 11,   shap:  0.27 },
      { name: 'n_ingressos',        value: 2,    shap:  0.22 },
      { name: 'grup_edat_90+',      value: 1,    shap:  0.16 },
      { name: 'cardiovascular',     value: 2,    shap:  0.13 },
      { name: 'diags_totals',       value: 11,   shap:  0.10 },
      { name: 'lab_slope',          value: -0.3, shap: -0.07 },
    ]
  }
];

export const METRICS = {
  mort:     { auc: 0.884, recall: 0.823, precision: 0.601 },
  urgencia: { auc: 0.790, recall: 0.748, precision: 0.412 },
  pcc:      { auc: 0.891, recall: 0.948, precision: 0.402 },
};